export function isOnSysRoute(pathname: string | null): boolean {
  if (!pathname) {
    return false;
  }
  const stripped = pathname.replace(/^\/[a-z]{2}(?=\/|$)/, '');
  return stripped === '/sys' || stripped.startsWith('/sys/');
}
